export default () => ({
  isStuck: false,

  init() {
    window.addEventListener('scroll', () => {
      const stickyTop = parseInt(window.getComputedStyle(this.$el).top);
      const currentTop = this.$el.getBoundingClientRect().top;
      this.$el.classList.toggle('stuck', currentTop === stickyTop);
    });
  },
});
